module.exports = __webpack_public_path__ + "static_pc/img/s01.846784a2.png";